module.exports = __webpack_public_path__ + "img/worksbot_img20022505.15fe7732.jpg";